module.exports = __webpack_public_path__ + "42d7320ec8dd86565d44c43b0a217d8b.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-bolditalic.ttf
 ** module id = 19
 ** module chunks = 0
 **/